module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f721466883998665b879.svg";


//////////////////
// WEBPACK FOOTER
// ./src/css/fonts/glyphicons-halflings-regular.svg
// module id = ./src/css/fonts/glyphicons-halflings-regular.svg
// module chunks = styles